import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface ExternalFilter {
  externalFilters: {
    [key: string]: {
      filterType: string;
      filterValue: string | number;
      filterValueTo?: string | number;
    };
  };
  externalFilterRows: any[];
  externalFilterColumnDefs: any[];
  externalFilterSortBy: string;
  externalFilterSortDirection: string;
}

const initialState: ExternalFilter = {
  externalFilters: {},
  externalFilterRows: [],
  externalFilterColumnDefs: [],
  externalFilterSortBy: 'date',
  externalFilterSortDirection: 'asc',
};

const externalFilterSlice = createSlice({
  name: 'ExternalFilter',
  initialState,
  reducers: {
    setExternalFilters(state, action: PayloadAction<{ externalFilters: ExternalFilter['externalFilters'], externalFilterRows: any[] }>) {
      state.externalFilters = action.payload.externalFilters;
      state.externalFilterRows = action.payload.externalFilterRows;
    },
    setExternalFiltersColumnDefs(state, action: PayloadAction<{ externalFilterColumnDefs: ExternalFilter['externalFilterColumnDefs'] }>) {
      state.externalFilterColumnDefs = action.payload.externalFilterColumnDefs;
    },
    setExternalFiltersSortBy(state, action: PayloadAction<string>) {
      state.externalFilterSortBy = action.payload;
    },
    setExternalFiltersSortDirection(state, action: PayloadAction<string>) {
      state.externalFilterSortDirection = action.payload;
    },
    clearExternalFilters(state) {
      state = initialState;
    }
  },
});

export const {
  setExternalFilters,
  setExternalFiltersColumnDefs,
  setExternalFiltersSortBy,
  setExternalFiltersSortDirection,
  clearExternalFilters
} = externalFilterSlice.actions;

export default externalFilterSlice.reducer;
